import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import * as React from 'react';
import { Component, createRef } from 'react';
import { defineElements } from '@lumieducation/h5p-webcomponents';
defineElements('h5p-editor');
var H5PEditorUI = /*#__PURE__*/function (_Component) {
  function H5PEditorUI(props) {
    var _this;
    _classCallCheck(this, H5PEditorUI);
    _this = _callSuper(this, H5PEditorUI, [props]);
    _this.loadContentCallbackWrapper = function (contentId) {
      return _this.props.loadContentCallback(contentId);
    };
    _this.onEditorLoaded = function (event) {
      if (_this.props.onLoaded) {
        _this.props.onLoaded(event.detail.contentId, event.detail.ubername);
      }
    };
    _this.onSaved = function (event) {
      if (_this.props.onSaved) {
        _this.props.onSaved(event.detail.contentId, event.detail.metadata);
      }
    };
    _this.onSaveError = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.onSaveError) {
                _this.props.onSaveError(event.detail.message);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.saveContentCallbackWrapper = function (contentId, requestBody) {
      return _this.props.saveContentCallback(contentId, requestBody);
    };
    _this.h5pEditor = createRef();
    return _this;
  }
  _inherits(H5PEditorUI, _Component);
  return _createClass(H5PEditorUI, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerEvents();
      this.setServiceCallbacks();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _a;
      this.registerEvents();
      this.setServiceCallbacks();
      (_a = this.h5pEditor.current) === null || _a === void 0 ? void 0 : _a.resize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unregisterEvents();
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate() {
      // Should the old editor instance be destroyed, we unregister from it...
      this.unregisterEvents();
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("h5p-editor", {
        ref: this.h5pEditor,
        "content-id": this.props.contentId
      });
    }
    /**
     * Call this method to save the current state of the h5p editor. This will
     * result in a call to the `saveContentCallback` that was passed in the
     * through the props.
     * @throws an error if there was a problem (e.g. validation error of the
     * content)
     */
  }, {
    key: "save",
    value: (function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _a;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (_a = this.h5pEditor.current) === null || _a === void 0 ? void 0 : _a.save();
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 6]]);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }())
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var _a, _b, _c, _d;
      (_a = this.h5pEditor.current) === null || _a === void 0 ? void 0 : _a.addEventListener('saved', this.onSaved);
      (_b = this.h5pEditor.current) === null || _b === void 0 ? void 0 : _b.addEventListener('editorloaded', this.onEditorLoaded);
      (_c = this.h5pEditor.current) === null || _c === void 0 ? void 0 : _c.addEventListener('save-error', this.onSaveError);
      (_d = this.h5pEditor.current) === null || _d === void 0 ? void 0 : _d.addEventListener('validation-error', this.onSaveError);
    }
  }, {
    key: "setServiceCallbacks",
    value: function setServiceCallbacks() {
      if (this.h5pEditor.current) {
        this.h5pEditor.current.loadContentCallback = this.loadContentCallbackWrapper;
        this.h5pEditor.current.saveContentCallback = this.saveContentCallbackWrapper;
      }
    }
  }, {
    key: "unregisterEvents",
    value: function unregisterEvents() {
      var _a, _b, _c, _d;
      (_a = this.h5pEditor.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('saved', this.onSaved);
      (_b = this.h5pEditor.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('editorloaded', this.onEditorLoaded);
      (_c = this.h5pEditor.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('save-error', this.onSaveError);
      (_d = this.h5pEditor.current) === null || _d === void 0 ? void 0 : _d.removeEventListener('validation-error', this.onSaveError);
    }
  }]);
}(Component); //# sourceMappingURL=H5PEditorUI.js.map
export { H5PEditorUI as default };